import React, { useCallback, useContext, useMemo } from "react";
import { FormattedMessage } from "react-intl";
const IndexContext = React.createContext(0);
const OnClickDataContext = React.createContext(null);
export default function StepList({ active, setActive, children }) {
    const onClickData = useMemo(() => [active, setActive], [active, setActive]);
    return React.createElement("ul", { className: "step step-sm step-icon-sm step step-inline step-item-between mb-3" }, React.Children.map(children, (element, index) => React.createElement(IndexContext.Provider, { value: index },
        React.createElement(OnClickDataContext.Provider, { value: onClickData }, element))));
}
export function StepItem({ title, translate, disabled }) {
    const index = useContext(IndexContext);
    const [activeStep, onClickParent] = useContext(OnClickDataContext);
    const onClick = useCallback(function () {
        onClickParent(index);
    }, [index, onClickParent]);
    return React.createElement("li", { className: "step-item focus" + (index === activeStep ? ' active' : '') },
        React.createElement("a", { className: "step-content-wrapper", onClick: onClick },
            React.createElement("span", { className: "step-icon step-icon-soft-dark" }, index + 1),
            React.createElement("div", { className: "step-content" },
                React.createElement("span", { className: "step-title" + (disabled ? " text-muted" : "") }, title || React.createElement(FormattedMessage, { id: translate })))));
}
